import styled from "styled-components";
import {
  Title,
  Body,
  FormItem as SundayFormItem,
  OtpInput,
  Headline,
} from "sunday-component";
import { Typography } from "@sunday/component";
import { Image, Modal as M, Row } from "antd";
import { color } from "src/styles/globals";
import { CheckOutlined as Cl } from "@ant-design/icons";
import { down } from "styled-breakpoints";
import Button from "../../Common/Button";

const maxContentWidth = "343px";
const iceCreamHeadingFontFamily =
  'var(--typeface-font-ic-en, "JUST Sans"), var(--typeface-font-ic-th, "Noto Sans Thai"), sans-serif';
const iceCreamBodyFontFamily =
  'var(--typeface-font-ic-th, "Noto Sans Thai"), sans-serif';

export const CheckOutlined = styled(Cl)`
  color: #1c7c4e;
  font-weight: bold;
  font-size: 17px;
  line-height: 18px;
`;

export const Verified = styled(Title).attrs({ level: 9 })`
  margin-left: 10px;
  color: #1c7c4e;
`;

export const SendOtpButton = styled(Button)`
  max-height: 48px;
  width: 100%;
  padding: 0px;
`;

export const SubmitOtpButton = styled(Button)`
  height: 48px;
  width: 100%;
  padding: 0 var(--space-l, 24px);
  border-radius: var(--radius-button, 9999px);
  font-family: ${iceCreamBodyFontFamily};
  font-size: 15px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: var(--typescale-tracking-base, 0px);

  &.sunday-component-btn-primary:not(:disabled) {
    border-color: var(--color-surface-ci-pri, #435dff);
    background-color: var(--color-surface-ci-pri, #435dff);
    color: var(--color-text-on-primary, #ffffff);
  }

  &:disabled,
  &.sunday-component-btn-primary:disabled {
    border-color: var(--color-surface-ci-pri, #435dff);
    background-color: var(--color-surface-ci-pri, #435dff);
    color: var(--color-text-on-primary, #ffffff);
    opacity: 1;

    * {
      color: var(--color-text-on-primary, #ffffff);
    }
  }

  ${down("lg")} {
    max-width: ${maxContentWidth};
    margin: 0 auto;
  }
`;

export const FormItem = styled(SundayFormItem)`
  margin: 0px;
`;

export const Space = styled.div`
  margin-top: 122px;
`;

export const Modal = styled(M)`
  max-width: 452px;
  font-family: ${iceCreamBodyFontFamily};

  .ant-modal-content {
    box-sizing: border-box;
    display: flex;
    width: 452px;
    max-width: 100%;
    height: 450px;
    flex-direction: column;
    gap: 0;
    padding: var(--space-l, 24px);
    overflow: hidden;
    opacity: 1;
    background: var(--color-surface-primary, #ffffff);
    border: 1px solid var(--color-stroke-default, #d9dbde);
    border-radius: var(--radius-card, 8px);
    box-shadow: none;
    transform: rotate(0deg);
  }

  .ant-modal-header {
    flex: none;
    margin: 0;
    padding: 40px 0 0;
    background: transparent;
    border: 0;
    border-radius: 0;
  }

  .ant-modal-close {
    top: var(--space-l, 24px);
    right: var(--space-l, 24px);
    width: 24px;
    height: 24px;
    margin: 0;
    color: var(--color-icon-primary, #202123);
  }

  .ant-modal-close-x {
    display: flex;
    width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;
    line-height: 24px;
  }

  .ant-modal-body {
    min-height: 0;
    flex: 1;
    padding: var(--space-s, 8px) 0 0;
  }

  .ant-modal-footer {
    display: flex;
    flex: none;
    margin: 0;
    padding: 0;
    background: transparent;
    border: 0;
  }

  ${down("lg")} {
    top: 0;
    width: 100vw !important;
    max-width: 100vw;
    margin: 0px;
    padding: 0px;
    .ant-modal,
    .ant-modal-content {
      height: 100vh;
      width: 100vw;
      margin: 0;
      top: 0;
    }
    .ant-modal-footer {
      display: flex;
      padding: 16px;
      position: fixed;
      bottom: 0;
      width: 100%;
      background: white;
    }
    .ant-modal-content {
      gap: 0;
      padding: 0;
      border: 0;
      border-radius: 0px;
    }
    .ant-modal-body {
      overflow: auto;
      padding: 0px;
      width: 100vw;
      height: calc(100vh - 141px);
    }
  }
`;

export const Content = styled.div`
  padding: 0;

  ${down("lg")} {
    max-width: ${maxContentWidth};
    margin: auto;
    padding: 24px 16px;
  }
`;

export const OtpBannerBg = styled.div`
  background-image: url("/static/pages/registerOtp/register-otp-banner-bg.svg");
  background-repeat: no-repeat;
  background-size: cover;
  height: 200px;
  border-radius: 0% 0% 100% 100% / 0% 0% 20% 20%;
  overflow: hidden;
  position: relative;
  padding: 0 16px;
  ${down("lg")} {
    height: 155px;
  }
`;

export const OtpBanner = styled.div`
  margin: auto;
  margin-top: 36px;
  ${down("lg")} {
    margin-top: 0px;
    max-width: ${maxContentWidth};
  }
`;

export const OtpBannerImage = styled.div`
  height: 175px;
  position: absolute;
  ${down("lg")} {
    height: 130px;
    bottom: -8px;
  }
`;

export const OtpBannerContent = styled.div`
  margin-left: auto;
  width: fit-content;
  height: 100%;
  align-content: center;
  ${down("lg")} {
    padding: 24px 16px;
  }
`;

export const BannerTitle = styled(Headline).attrs({ level: 6 })`
  color: ${color.white};
`;

export const BannerSubtitle = styled(Body).attrs({ level: 6 })`
  color: ${color.white};
  margin-top: 6px;
`;

export const ModalTitle = styled(Typography.Headline).attrs({
  designLevel: 2,
  weight: "bold",
})`
  && {
    --typography-heading-font-family: ${iceCreamHeadingFontFamily};
    --typography-heading-font-weight-bold: 700;
    --typography-h2-font-size: var(--typescale-size-h-2, 24px);
    --typography-h2-line-height: var(--typescale-line-height-h-2, 32px);

    margin: 0;
    color: var(--color-text-primary, #202123);
    font-family: ${iceCreamHeadingFontFamily};
    font-size: var(--typescale-size-h-2, 24px);
    font-weight: 700;
    line-height: var(--typescale-line-height-h-2, 32px);
    letter-spacing: var(--typescale-tracking-en-h-2, -1px);
    text-align: left;
    vertical-align: middle;
    word-break: break-word;
  }
`;

export const ModalCloseIcon = styled.div`
  position: absolute;
  display: flex;
  items: center;
  width: 24px;
  height: 100%;
  right: 0;
  top: 0;
`;

export const CloseIcon = styled(Image)`
  && {
    display: block;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
`;

export const SubtitleBody = styled.div`
  display: grid;
  gap: 4px;
  margin: 0;
  color: var(--color-text-secondary, #5f6468);
  font-family: ${iceCreamBodyFontFamily};
  font-size: 15px;
  font-weight: 300;
  font-variation-settings: "wdth" 100;
  line-height: 24px;
  letter-spacing: var(--typescale-tracking-base, 0px);
  vertical-align: middle;
`;

export const SubtitleBold = styled(Typography.Body).attrs({
  designLevel: 2,
  weight: "bold",
})`
  && {
    margin: 0;
    color: var(--color-text-primary, #202123);
    --typography-base-font-family: ${iceCreamBodyFontFamily};
    --typography-base-font-weight-bold: 700;

    font-family: ${iceCreamBodyFontFamily};
    font-size: 15px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: var(--typescale-tracking-base, 0px);
    vertical-align: middle;
  }
`;

export const ReferenceBody = styled(Typography.Body).attrs({
  designLevel: 2,
  weight: "regular",
})`
  && {
    margin: 0;
    color: var(--color-text-disabled, #9fa6ad);
    --typography-base-font-family: ${iceCreamBodyFontFamily};
    --typography-base-font-weight-regular: 300;

    font-family: ${iceCreamBodyFontFamily};
    font-size: 15px;
    font-weight: 300;
    font-variation-settings: "wdth" 100;
    line-height: 24px;
    letter-spacing: var(--typescale-tracking-base, 0px);
    vertical-align: middle;
  }
`;

export const InputRow = styled(Row)`
  width: 343px;
  max-width: 100%;
  margin-top: 24px;
  margin-bottom: 24px;
  max-height: fit-content;
`;

export const ButtonTitle = styled(Title)``;

export const EditButton = styled.button`
  width: fit-content;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--color-text-ci-pri, #435dff);
  cursor: pointer;
  font-family: ${iceCreamBodyFontFamily};
  font-size: 15px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: var(--typescale-tracking-base, 0px);
  text-decoration: underline;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;
`;

export const ResendButton = styled.button`
  width: fit-content;
  margin-top: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--color-text-ci-pri, #435dff);
  cursor: pointer;
  font-family: ${iceCreamBodyFontFamily};
  font-size: 15px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: var(--typescale-tracking-base, 0px);
  text-align: left;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;
`;

export const ResendWait = styled(Typography.Body).attrs({
  designLevel: 2,
  weight: "bold",
})`
  && {
    width: fit-content;
    margin-top: 4px;
    color: var(--color-text-secondary, #5f6468);
    font-family: ${iceCreamBodyFontFamily};
    font-size: 15px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: var(--typescale-tracking-base, 0px);
    vertical-align: middle;
  }
`;

export const OtpField = styled(OtpInput)``;

export const OtpFieldContainer = styled(SundayFormItem)`
  width: 343px;
  max-width: 100%;
  margin: 0px;

  .sunday-component-form-item-control {
    row-gap: 8px;
  }

  .sunday-component-form-item-control-input-content > div > div {
    display: flex;
    gap: 8px;
    width: 100%;
  }

  .sunday-component-form-item-control-input-content > div > div > div {
    min-width: 0;
    flex: 1 0 0;
    height: 54px;
  }

  .sunday-component-form-item-control-input-content input {
    width: 100% !important;
    height: 54px;
    margin: 0;
    padding: 0;
    border: 1px solid var(--color-stroke-default, #d9dbde);
    border-radius: var(--radius-card, 8px);
    color: var(--color-text-primary, #202123);
    caret-color: var(--color-text-ci-pri, #435dff);
    font-family: ${iceCreamBodyFontFamily};
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: var(--typescale-tracking-base, 0px);
    text-align: center;
  }

  .sunday-component-form-item-control-input-content input:focus {
    border-color: var(--color-stroke-ci-pri, #435dff);
    box-shadow: none;
    outline: none;
  }

  .sunday-component-form-item-control-input-content input::selection {
    color: inherit;
    background: none;
  }
`;
